export default __webpack_public_path__ + "static/media/internet_keywords.de220458.csv";